import React from 'react';
import { withTranslation } from "react-i18next";
import './Reporting.scss';
import Utils from '../../../core/utilities/Utils';
import ReportingUtils from '../../../core/utilities/ReportingUtils';
import { ReportPageType } from '../../../core/constants/common';

const ReportingStandardData = ({ t,  page, disclosureQuestions = [], periodStart, periodEnd }) => {

	const dataPointData = {
		'ENVIRONMENTAL': [],
		'SOCIAL': [],
		'GOVERNANCE': []
	};
	page?.json?.dataPoints?.forEach((dataPoint) => {
		if (dataPoint.topicCategory === 'ENVIRONMENTAL') {
			dataPointData['ENVIRONMENTAL'].push(dataPoint);
		} else if (dataPoint.topicCategory === 'SOCIAL') {
			dataPointData['SOCIAL'].push(dataPoint);
		} else if (dataPoint.topicCategory === 'GOVERNANCE') {
			dataPointData['GOVERNANCE'].push(dataPoint);
		}
	});
	const topicData = {
		'ENVIRONMENTAL': [],
		'SOCIAL': [],
		'GOVERNANCE': []
	};
	page?.json?.topics?.forEach((topic) => {
		if (topic.categoryType === 'ENVIRONMENTAL') {
			topicData['ENVIRONMENTAL'].push(topic);
		} else if (topic.categoryType === 'SOCIAL') {
			topicData['SOCIAL'].push(topic);
		} else if (topic.categoryType === 'GOVERNANCE') {
			topicData['GOVERNANCE'].push(topic);
		}
	});

	const colCount = page.type === ReportPageType.SUST_CONTENT_INDEX ? 7 : 3;

	const topicsToRender = (topic, tIndex) => {
		return <>
			<tr border="1" key={`topic-${tIndex + 1}`}>
				<td colSpan={colCount} key={`topic-td-${tIndex + 1}`}
					style={{ border: 'none', padding: '.5rem .5rem', }}>
					<b style={{ color: '#0d6efd' }}>{topic?.topicName}</b>
				</td>
			</tr>
			{
				topic.metricData?.map((metric, mIndex) => {
					return (
						<>
							{renderMetricRow(topic, tIndex, metric, mIndex)}
							{metric.datapointCount > 0 && renderDataPoints(metric, mIndex)}
						</>
					);
				})
			}
		</>;
	}

	const renderDataPoints = (metric, mIndex) => {
		if (page.type === ReportPageType.SUST_CONTENT_INDEX) return <></>;
		
		return (
			metric.dataPoints?.map((dp, dpIndex) => {
				return (
					<tr border="1" key={`dp-${mIndex + 1}-${dpIndex + 1}`}>
						<td key={`dp-td-0-${mIndex}-${dpIndex + 1}`}
							style={{
								paddingLeft: '1.5rem',
								paddingRight: '.5rem',
								paddingTop: '.5rem',
								paddingBottom: '.5rem',
								borderTop: "1px solid #dee2e6",
								borderBottom: "1px solid #dee2e6",
								borderLeft: 'none',
								borderRight: 'none',
								width: '10%',
							}}></td>
						<td key={`dp-td-1-${mIndex}-${dpIndex + 1}`}
							style={{
								padding: '.5rem .5rem',
								borderTop: "1px solid #dee2e6",
								borderBottom: "1px solid #dee2e6",
								borderLeft: 'none',
								borderRight: 'none',
								textAlign: 'right',
								width: '50%',
							}}>{dp?.name}</td>
						<td key={`dp-td-2-${mIndex}-${dpIndex + 1}`}
						className=''
							style={{
								backgroundColor: 'grey',
								color: 'white',
								padding: '.5rem .5rem',
								borderTop: "1px solid #dee2e6",
								borderBottom: "1px solid #dee2e6",
								borderLeft: 'none',
								borderRight: 'none',
								width: '40%',
							}}>
							<span style={{ fontWeight: 'bold' }}>{dp.combined ? `${Utils.formattedNumber(dp.combined)} ` : ''}</span>
							<span style={{ fontWeight: 'bold' }}>{dp?.unit}</span>
						</td>
					</tr>
				);
			})
		);
	};

	const questionToRender = (question, index, childIndex = -1) => {
		let answer = ' ';
		question?.answers?.forEach((a, aIndex) => {
			answer += `${a.answer}`;
			if (aIndex === question?.answers?.length - 1) return;

			answer += `, `;
		});
		return (<>
			<tr border="1" key={`question-${index + 1}-${childIndex + 1}`}>
				<td key={`question-td-0-${index + 1}-${childIndex + 1}`}
					style={{
						padding: '.5rem .5rem',
						borderTop: "1px solid #dee2e6",
						borderBottom: "1px solid #dee2e6",
						borderLeft: 'none',
						borderRight: 'none',
						width: '10%',
					}}>{childIndex >= 0 ? '' : (question?.standardCodes?.length > 0 ? question?.standardCodes.toString() : question?.code)}</td>
				<td key={`question-td-1-${index + 1}-${childIndex + 1}`}
					style={{
						padding: '.5rem .5rem',
						borderTop: "1px solid #dee2e6",
						borderBottom: "1px solid #dee2e6",
						borderLeft: 'none',
						borderRight: 'none',
						width: '50%',
					}}>{childIndex >= 0 ? `${childIndex + 1} - ${question?.name}` : question?.name}</td>
				<td key={`question-td-2-${index + 1}-${childIndex + 1}`}
					style={{
						backgroundColor: 'grey',
						color: 'white',
						padding: '.5rem .5rem',
						borderTop: "1px solid #dee2e6",
						borderBottom: "1px solid #dee2e6",
						borderLeft: 'none',
						borderRight: 'none',
						width: '40%',
					}}>
					{
						<span style={{ fontWeight: 'bold' }}>{answer}</span>
					}
				</td>
			</tr>
			{
				question.children?.map((q, cIndex) => {
					return <>{questionToRender(q, index, cIndex)}</>
				})
			}
		</>);
	}

	const renderDisclosureQuestions = () => {
		if (page.type === ReportPageType.SUST_CONTENT_INDEX) return <></>;

		const gri2Questions = [];
		const gri3Questions = [];
		disclosureQuestions?.forEach(q => {
			if (q?.standardCodes?.findIndex(s => s === '3-1' || s === '3-2') >= 0) {
				gri3Questions.push(q);
			} else {
				gri2Questions.push(q);
			}
		});
		return (disclosureQuestions?.length > 0 &&
			<>
				<tr border="1" key="disclosureQuestions" style={{}}>
					<td colSpan="3" style={{
						padding: '.5rem .5rem',
						borderTop: "2px solid #0d6efd",
						borderBottom: "2px solid #0d6efd",
						borderLeft: 'none',
						borderRight: 'none',
					}}>
						<b>GRI 2: General Disclosures {periodStart} to {periodEnd}</b>
					</td>
				</tr>
				{
					gri2Questions?.map((question, index) => {						
						return questionToRender(question, index);
					})
				}
				{
					gri3Questions?.length > 0 &&
					<>
					<tr border="1" key="disclosureQuestions" style={{}}>
						<td colSpan="3" style={{
							padding: '.5rem .5rem',
							borderTop: "2px solid #0d6efd",
							borderBottom: "2px solid #0d6efd",
							borderLeft: 'none',
							borderRight: 'none',
						}}>
							<b>GRI 3: Material Topics {periodStart} to {periodEnd}</b>
						</td>
					</tr>
					{
						gri3Questions?.map((question, index) => {						
							return questionToRender(question, index);
						})
					}
					</>
				}				
			</>);
	};

	const renderReferPageLink = (metric) => {
		const pageType = ReportingUtils.getPageTypeFromQualitativeMetricCode(metric?.code);
		if (!pageType) return (<span style={{ fontWeight: 'bold' }}>{metric?.aggregatedAnswer ?? ''}</span>);

		return (
			<span><a href="#" onClick={(e) => { e.preventDefault(); }}
				className='cursor'>Refer {pageType} page</a>
			</span>
		);
	}

	const renderHeaders = () => {
		if (page.type === ReportPageType.SUST_CONTENT_INDEX) {
			return (
				<>
					<tr>
						<th style={{ width: '10%', fontSize: '10px', textAlign: 'left', border: 'none' }}>Topic</th>
						<th style={{ width: '50%', fontSize: '10px', textAlign: 'left', border: 'none' }}>GRI Disclosure</th>
						<th style={{ width: '40%', fontSize: '10px', textAlign: 'left', border: 'none' }}>ESRS Standard</th>
						<th style={{ width: '40%', fontSize: '10px', textAlign: 'left', border: 'none' }}>VSME Category</th>
						<th style={{ width: '40%', fontSize: '10px', textAlign: 'left', border: 'none' }}>SDG Alignment</th>
						<th style={{ width: '40%', fontSize: '10px', textAlign: 'left', border: 'none' }}>SASB (if applicable)</th>
						<th style={{ width: '40%', fontSize: '10px', textAlign: 'left', border: 'none' }}>Report section/Page</th>
					</tr>
				</>
			);
		}
		return (
			<>
				<tr>
					<th style={{ width: '10%', fontSize: '10px', textAlign: 'left', border: 'none' }}>Disclosure number</th>
					<th style={{ width: '50%', fontSize: '10px', textAlign: 'left', border: 'none' }}>Description</th>
					<th style={{ width: '40%', fontSize: '10px', textAlign: 'left', border: 'none' }}>Response</th>
				</tr>
			</>
		);
	};

	const renderMetricRow = (topic, tIndex, metric, mIndex) => {
		return (
			<tr border="1" key={`metric-${tIndex + 1}-${mIndex + 1}`}>
				<td key={`metric-td-0-${tIndex + 1}`}
					style={{
						padding: '.5rem .5rem',
						borderTop: "1px solid #dee2e6",
						borderBottom: "1px solid #dee2e6",
						borderLeft: 'none',
						borderRight: 'none',
						width: '10%',
					}}>{getGRICodeMappingFor(metric?.metric?.code)}</td>
				<td key={`metric-td-1-${tIndex + 1}`}
					style={{
						padding: '.5rem .5rem',
						borderTop: "1px solid #dee2e6",
						borderBottom: "1px solid #dee2e6",
						borderLeft: 'none',
						borderRight: 'none',
						width: '50%',
					}}>{metric?.metric?.name}</td>
				<td key={`metric-td-2-${tIndex + 1}`}
					style={{
						backgroundColor: 'grey',
						color: 'white',
						padding: '.5rem .5rem',
						borderTop: "1px solid #dee2e6",
						borderBottom: "1px solid #dee2e6",
						borderLeft: 'none',
						borderRight: 'none',
						width: '40%',
					}}>
					{
						metric?.metric?.category === 'QUALITATIVE'
							?
							<>{renderReferPageLink(metric.metric)}</>
							:
							<>
								<span style={{ fontWeight: 'bold' }}>{metric.value ? `${Utils.formattedNumber(metric.value)} ` : ''}</span>
								<span style={{ fontWeight: 'bold' }}>{metric?.metric?.unitOfMeasure}</span>
							</>
					}
				</td>
			</tr>
		);
	};
	
	const renderGRIPageTopics = () => {
		if (page.type !== ReportPageType.METRIC_DATA) return <></>;

		return (
			<>
			{
				Object.keys(dataPointData)?.map((key) => {
					return dataPointData[key]?.length > 0 &&
						<>
							<tr border="1" key={`topic${key}`} style={{}}>
								<td colSpan={colCount} style={{
									padding: '.5rem .5rem',
									borderTop: "2px solid #0d6efd",
									borderBottom: "2px solid #0d6efd",
									borderLeft: 'none',
									borderRight: 'none',
								}}>
									<b>{key}</b>
								</td>
							</tr>
							{
								dataPointData[key]
									?.sort((a, b) => a.topicSortOrder - b.topicSortOrder)
									?.map((topic, tIndex) => {
										return topicsToRender(topic, tIndex);
									})
							}
						</>
				})
			}
			</>
		);
	};

	const renderSustainabilityPageTopics = () => {
		if (page.type !== ReportPageType.SUST_CONTENT_INDEX) return <></>;

		return (
			<>
			{
				Object.keys(topicData)?.map((key) => {
					return topicData[key]?.length > 0 &&
						<>
							<tr border="1" key={`topic${key}`} style={{}}>
								<td colSpan={colCount} style={{
									padding: '.5rem .5rem',
									borderTop: "2px solid #0d6efd",
									borderBottom: "2px solid #0d6efd",
									borderLeft: 'none',
									borderRight: 'none',
								}}>
									<b>{key}</b>
								</td>
							</tr>
							{
								topicData[key]
									?.sort((a, b) => a.sortOrder - b.sortOrder)
									?.map((topic, tIndex) => {
										return sustTopicsToRender(topic, tIndex);
									})
							}
						</>
				})
			}
			</>
		);
	};

	const sustTopicsToRender = (topic, tIndex) => {
		return <>
			<tr border="1" key={`topic-${tIndex + 1}`}>
				<td colSpan={colCount} key={`topic-td-${tIndex + 1}`}
					style={{ border: 'none', padding: '.5rem .5rem', }}>
					<b style={{ color: '#0d6efd' }}>{topic?.name}</b>
				</td>
			</tr>
			{
				topic.metrics?.sort((a, b) => a.sortOrder - b.sortOrder)?.map((metric, mIndex) => {
					return (
						<>
							{renderSustMetricRow(topic, tIndex, metric, mIndex)}
						</>
					);
				})
			}
		</>;
	}

	const renderSustMetricRow = (topic, tIndex, metric, mIndex) => {
		return (
			<tr border="1" key={`metric-${tIndex + 1}-${mIndex + 1}`}>
				<td key={`metric-td-0-${tIndex + 1}`}
					style={{
						padding: '.5rem .5rem',
						borderTop: "1px solid #dee2e6",
						borderBottom: "1px solid #dee2e6",
						borderLeft: 'none',
						borderRight: 'none',
						width: '10%',
					}}>{metric?.name}</td>
				<td key={`metric-td-1-${tIndex + 1}`}
					style={{
						padding: '.5rem .5rem',
						borderTop: "1px solid #dee2e6",
						borderBottom: "1px solid #dee2e6",
						borderLeft: 'none',
						borderRight: 'none',
						width: '50%',
					}}>{getGRICodeMappingFor(metric?.code)}</td>
				<td key={`metric-td-2-${tIndex + 1}`}
					style={{
						padding: '.5rem .5rem',
						borderTop: "1px solid #dee2e6",
						borderBottom: "1px solid #dee2e6",
						borderLeft: 'none',
						borderRight: 'none',
						width: '50%',
					}}>{getESRSCodeMappingFor(metric?.code)}</td>
				<td key={`metric-td-3-${tIndex + 1}`}
					style={{
						padding: '.5rem .5rem',
						borderTop: "1px solid #dee2e6",
						borderBottom: "1px solid #dee2e6",
						borderLeft: 'none',
						borderRight: 'none',
						width: '50%',
					}}></td>
				<td key={`metric-td-4-${tIndex + 1}`}
					style={{
						padding: '.5rem .5rem',
						borderTop: "1px solid #dee2e6",
						borderBottom: "1px solid #dee2e6",
						borderLeft: 'none',
						borderRight: 'none',
						width: '50%',
					}}></td>
				<td key={`metric-td-5-${tIndex + 1}`}
					style={{
						padding: '.5rem .5rem',
						borderTop: "1px solid #dee2e6",
						borderBottom: "1px solid #dee2e6",
						borderLeft: 'none',
						borderRight: 'none',
						width: '50%',
					}}></td>
				<td key={`metric-td-6-${tIndex + 1}`}
					style={{
						padding: '.5rem .5rem',
						borderTop: "1px solid #dee2e6",
						borderBottom: "1px solid #dee2e6",
						borderLeft: 'none',
						borderRight: 'none',
						width: '50%',
					}}>{topic.name}</td>					
			</tr>
		);
	};

	const getGRICodeMappingFor = (metricCode) => {
		if (metricCode) {
			if (page?.json?.metricCodeMappings 
				&& page?.json?.metricCodeMappings !== null
				&& page?.json?.metricCodeMappings[metricCode]
				&& page?.json?.metricCodeMappings[metricCode]['GRI']) {
				return page.json.metricCodeMappings[metricCode]['GRI'].toString();
			} else {
				return page.type === ReportPageType.SUST_CONTENT_INDEX ? '' : metricCode;
			}
		}		
		return '';
	};

	const getESRSCodeMappingFor = (metricCode) => {
		if (metricCode) {
			if (page?.json?.metricCodeMappings 
				&& page?.json?.metricCodeMappings !== null
				&& page?.json?.metricCodeMappings[metricCode]
				&& page?.json?.metricCodeMappings[metricCode]['ESRS']) {
				return page.json.metricCodeMappings[metricCode]['ESRS'].toString();
			} else {
				return page.type === ReportPageType.SUST_CONTENT_INDEX ? '' : metricCode;
			}
		}	
		return '';
	};

	return (
		<div id="metricDataTable">
			<div className='row m-0'>
				<div className='col-lg-12 p-2'>
					<table className='table Gritable_card'
						border="1"
						style={{
							width: '100%',
							marginBottom: '1rem',
							verticalAlign: 'top',
							borderCollapse: 'collapse',
							border: 'none',
							fontFamily: 'Arial, sans-serif',
							fontWeight: '400',
						}}>
						<thead>{renderHeaders()}</thead>
						<tbody style={{ borderTop: "2px solid #0d6efd" }}>
							{renderDisclosureQuestions()}
							{renderGRIPageTopics()}
							{renderSustainabilityPageTopics()}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
}

export default withTranslation()(ReportingStandardData);
